export function Row(props) {
  return <div className='row'>{props.children}</div>
}

export function Col({opt = null, width = null, ...props}) {
  return <div className={['col', opt, width].filter(Boolean).join('-')}>{props.children}</div>
}